  <template>
  <div class="customer">
    <div class="banner">
      <img src="../../assets/dkh_banner.png" alt="">
    </div>
    <div class="section_w">
      <div class="container">
        <div class="section_title left">
          <p>
            大客户 <span></span>
          </p>
          <aside>
            BIG CUSTOMER
          </aside>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/zgpan.png" alt="">
              <p>
                中国平安
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/China_Mobile_logo.png" alt="">
              <p>
                中国移动
              </p>
            </div>
          </div>
           <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/telecommunications_logo.png" alt="">
              <p>
                中国电信
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/Life_logo.png" alt="">
              <p>
                中国人寿
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/Meituan_logo.png" alt="">
              <p>
                美团
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/Futian_logo.png" alt="">
              <p>
                福田汽车
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/Lexus_logo.png" alt="">
              <p>
                凌志股份
              </p>
            </div>
          </div>
         
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/zhonglian_logo.png" alt="">
              <p>
                中联数据
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/zl_logo.png" alt="">
              <p>
                中粮期货
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/Sinochem_logo.png" alt="">
              <p>
                中化能源
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/zhongmeishengwu.png" alt="">
              <p>
                科美生物
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-xs-6 text-center">
            <div class="border">
              <img src="../../assets/renmin.png" alt="">
              <p>
                人民数字
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    components: {
      Footer
    },
    props: {
    }
  }
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner img {
    width: 100%;
  }
  .section_title p span {
    color: #333333;
    font-size: 2.4rem;
  }
  .customer .border {
    border: 1px solid #ccc;
    padding: 20px 0px;
    margin-bottom: 30px;
  }
  .customer .border img {
    height: 100px;
    margin-bottom: 20px;
  }
  @media (max-width: 991px) {
    .section_title p span {
      display: block;
    }

  }
</style>
